{
  "about.blocks": "Servidors moderaus",
  "about.contact": "Contacto:",
  "about.disclaimer": "Mastodon ye software de codigo ubierto, y una marca comercial de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Razón no disponible",
  "about.domain_blocks.preamble": "Mastodon normalment te permite veyer lo conteniu y interactuar con os usuarios de qualsequier atro servidor en o fediverso. Estas son las excepcions que s'han feito en este servidor en particular.",
  "about.domain_blocks.silenced.explanation": "Normalment no veyerás perfils y conteniu d'este servidor, de no estar que lo busques explicitament u sigas bella cuenta.",
  "about.domain_blocks.silenced.title": "Limitau",
  "about.domain_blocks.suspended.explanation": "Garra dato d'este servidor será procesau, almagazenau u intercambiau, fendo imposible qualsequier interacción u comunicación con os usuarios d'este servidor.",
  "about.domain_blocks.suspended.title": "Suspendiu",
  "about.not_available": "Esta información no ye disponible en este servidor.",
  "about.powered_by": "Retz socials descentralizaus con tecnolochía de {mastodon}",
  "about.rules": "Reglas d'o servidor",
  "account.add_or_remove_from_list": "Adhibir u eliminar de listas",
  "account.badges.bot": "Bot",
  "account.badges.group": "Grupo",
  "account.block": "Blocar a @{name}",
  "account.block_domain": "Blocar dominio {domain}",
  "account.blocked": "Blocau",
  "account.cancel_follow_request": "Retirar solicitut de seguimiento",
  "account.disable_notifications": "Deixar de notificar-me quan @{name} publique bella cosa",
  "account.edit_profile": "Editar perfil",
  "account.enable_notifications": "Notificar-me quan @{name} publique bella cosa",
  "account.endorse": "Amostrar en perfil",
  "account.follow": "Seguir",
  "account.followers": "Seguidores",
  "account.followers.empty": "Encara no sigue dengún a este usuario.",
  "account.following": "Seguindo",
  "account.follows.empty": "Este usuario encara no sigue a dengún.",
  "account.go_to_profile": "Ir ta lo perfil",
  "account.hide_reblogs": "Amagar retutz de @{name}",
  "account.joined_short": "S'unió",
  "account.languages": "Cambiar idiomas suscritos",
  "account.link_verified_on": "Lo proprietario d'este link estió comprebau lo {date}",
  "account.locked_info": "Lo estau de privacidat d'esta cuenta ye configurau como blocau. Lo proprietario ha de revisar manualment qui puede seguir-le.",
  "account.media": "Multimedia",
  "account.mention": "Mencionar a @{name}",
  "account.moved_to": "{name} ha indicau que la suya nueva cuenta ye agora:",
  "account.mute": "Silenciar a @{name}",
  "account.muted": "Silenciau",
  "account.open_original_page": "Ubrir pachina orichinal",
  "account.posts": "Publicacions",
  "account.report": "Denunciar a @{name}",
  "account.requested_follow": "{name} ha demandau seguir-te",
  "account.share": "Compartir lo perfil de @{name}",
  "account.show_reblogs": "Amostrar retutz de @{name}",
  "account.unblock": "Desblocar a @{name}",
  "account.unblock_domain": "Amostrar a {domain}",
  "account.unblock_short": "Desblocar",
  "account.unendorse": "No amostrar en o perfil",
  "account.unfollow": "Deixar de seguir",
  "account.unmute": "Deixar de silenciar a @{name}",
  "account.unmute_short": "Deixar de silenciar",
  "account_note.placeholder": "Clic pa anyadir nota",
  "admin.dashboard.daily_retention": "Taxa de retención d'usuarios per día dimpués d'o rechistro",
  "admin.dashboard.monthly_retention": "Taxa de retención d'usuarios per mes dimpués d'o rechistro",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mes de rechistro",
  "admin.dashboard.retention.cohort_size": "Nuevos usuarios",
  "alert.rate_limited.message": "Per favor reintente dimpués de {retry_time, time, medium}.",
  "alert.rate_limited.title": "Tarifa limitada",
  "alert.unexpected.message": "I habió una error inasperada.",
  "alert.unexpected.title": "Ups!",
  "announcement.announcement": "Anuncio",
  "attachments_list.unprocessed": "(sin procesar)",
  "audio.hide": "Amagar audio",
  "boost_modal.combo": "Puetz fer clic en {combo} pa blincar este aviso la proxima vegada",
  "bundle_column_error.copy_stacktrace": "Copiar informe d'error",
  "bundle_column_error.error.body": "La pachina solicitada no podió estar renderizada. Podría deber-se a una error en o nuestro codigo u a un problema de compatibilidat con o navegador.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "S'ha produciu una error en intentar cargar esta pachina. Esto puede deber-se a un problema temporal con a tuya connexión a internet u a este servidor.",
  "bundle_column_error.network.title": "Error de ret",
  "bundle_column_error.retry": "Intenta-lo de nuevo",
  "bundle_column_error.return": "Tornar ta l'inicio",
  "bundle_column_error.routing.body": "No se podió trobar la pachina solicitada. Yes seguro que la URL en a barra d'adrezas ye correcta?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zarrar",
  "bundle_modal_error.retry": "Intenta-lo de nuevo",
  "closed_registrations.other_server_instructions": "Como Mastodon ye descentralizau, puetz creyar una cuenta en unatro servidor y seguir interactuando con este.",
  "closed_registrations_modal.description": "La creyación d'una cuenta en {domain} no ye posible actualment, pero tiene en cuenta que no amenestes una cuenta especificament en {domain} pa usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Buscar unatro servidor",
  "closed_registrations_modal.preamble": "Mastodon ye descentralizau, per lo que no importa án creyes la tuya cuenta, podrás seguir y interactuar con qualsequier persona en este servidor. Mesmo puetz alochar-lo tu mesmo!",
  "closed_registrations_modal.title": "Rechistrar-se en Mastodon",
  "column.about": "Sobre",
  "column.blocks": "Usuarios blocaus",
  "column.bookmarks": "Marcadors",
  "column.community": "Linia de tiempo local",
  "column.directory": "Buscar perfils",
  "column.domain_blocks": "Dominios amagaus",
  "column.follow_requests": "Solicitutz de seguimiento",
  "column.home": "Inicio",
  "column.lists": "Listas",
  "column.mutes": "Usuarios silenciaus",
  "column.notifications": "Notificacions",
  "column.pins": "Publicacions fixadas",
  "column.public": "Linia de tiempo federada",
  "column_back_button.label": "Dezaga",
  "column_header.hide_settings": "Amagar configuración",
  "column_header.moveLeft_settings": "Mover columna a la zurda",
  "column_header.moveRight_settings": "Mover columna a la dreita",
  "column_header.pin": "Fixar",
  "column_header.show_settings": "Amostrar achustes",
  "column_header.unpin": "Deixar de fixar",
  "community.column_settings.local_only": "Solo local",
  "community.column_settings.media_only": "Solo media",
  "community.column_settings.remote_only": "Solo remoto",
  "compose.language.change": "Cambiar idioma",
  "compose.language.search": "Buscar idiomas...",
  "compose_form.direct_message_warning_learn_more": "Aprender mas",
  "compose_form.encryption_warning": "Las publicacions en Mastodon no son zifradas de cabo a cabo. No comparta garra información sensible en Mastodon.",
  "compose_form.hashtag_warning": "Este tut no s'amostrará en cada etiqueta, ya que no ye publico. Nomás los tuts publicos se pueden buscar per etiqueta.",
  "compose_form.lock_disclaimer": "La tuya cuenta no ye {locked}. Totz pueden seguir-te pa veyer las tuyas publicacions nomás pa seguidores.",
  "compose_form.lock_disclaimer.lock": "blocau",
  "compose_form.placeholder": "En qué yes pensando?",
  "compose_form.poll.duration": "Duración d'a enqüesta",
  "compose_form.poll.switch_to_multiple": "Modificar enqüesta pa permitir multiples opcions",
  "compose_form.poll.switch_to_single": "Modificar enqüesta pa permitir una sola opción",
  "compose_form.spoiler.marked": "Texto amagau dimpués de l'alvertencia",
  "compose_form.spoiler.unmarked": "Texto no amagau",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Blocar",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "Yes seguro que quiers borrar esta publicación?",
  "confirmations.delete_list.confirm": "Eliminar",
  "confirmations.delete_list.message": "Seguro que quiers borrar esta lista permanentment?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tiens cambios sin alzar en a descripción u vista previa d'o fichero audiovisual, descartar-los de totz modos?",
  "confirmations.logout.confirm": "Zarrar sesión",
  "confirmations.logout.message": "Yes seguro de querer zarrar la sesión?",
  "confirmations.mute.confirm": "Silenciar",
  "confirmations.redraft.confirm": "Borrar y tornar ta borrador",
  "confirmations.unfollow.confirm": "Deixar de seguir",
  "conversation.delete": "Borrar conversación",
  "conversation.mark_as_read": "Marcar como leyiu",
  "conversation.open": "Veyer conversación",
  "conversation.with": "Con {names}",
  "copypaste.copied": "Copiau",
  "directory.federated": "Dende lo fediverso conoixiu",
  "directory.local": "Nomás de {domain}",
  "directory.new_arrivals": "Recientment plegaus",
  "directory.recently_active": "Recientment activo",
  "disabled_account_banner.account_settings": "Achustes d'a cuenta",
  "disabled_account_banner.text": "La tuya cuenta {disabledAccount} ye actualment deshabilitada.",
  "dismissable_banner.community_timeline": "Estas son las publicacions publicas mas recients de personas que las suyas cuentas son alochadas en {domain}.",
  "dismissable_banner.dismiss": "Descartar",
  "embed.instructions": "Anyade esta publicación a lo tuyo puesto web con o siguient codigo.",
  "embed.preview": "Asinas ye como se veyerá:",
  "emoji_button.activity": "Actividat",
  "emoji_button.clear": "Limpiar",
  "emoji_button.custom": "Personalizau",
  "emoji_button.flags": "Marcas",
  "emoji_button.food": "Minchada y bebida",
  "emoji_button.label": "Ficar emoji",
  "emoji_button.nature": "Naturaleza",
  "emoji_button.not_found": "No i hai garra emoji coincident",
  "emoji_button.objects": "Obchectos",
  "emoji_button.people": "Chent",
  "emoji_button.recent": "Usaus freqüentment",
  "emoji_button.search": "Buscar...",
  "emoji_button.search_results": "Resultaus de busqueda",
  "emoji_button.symbols": "Simbolos",
  "emoji_button.travel": "Viaches y puestos",
  "empty_column.account_suspended": "Cuenta suspendida",
  "empty_column.account_timeline": "No i hai publicacions aquí!",
  "empty_column.account_unavailable": "Perfil no disponible",
  "empty_column.blocks": "Encara no has blocau a garra usuario.",
  "empty_column.bookmarked_statuses": "Encara no tiens garra publicación alzada como marcador. Quan alces una, s'amostrará aquí.",
  "empty_column.community": "La linia de tiempo local ye vueda. Escribe bella cosa pa empecipiar la fiesta!",
  "empty_column.domain_blocks": "Encara no i hai dominios amagaus.",
  "empty_column.explore_statuses": "Cosa ye en tendencia en este momento. Revisa mas tarde!",
  "empty_column.follow_requests": "No tiens garra petición de seguidor. Quan recibas una, s'amostrará aquí.",
  "empty_column.hashtag": "No i hai cosa en este hashtag encara.",
  "empty_column.home": "La tuya linia temporal ye vueda! Sigue a mas personas pa replenar-la. {suggestions}",
  "empty_column.list": "No i hai cosa en esta lista encara. Quan miembros d'esta lista publiquen nuevos estatus, estes amaneixerán qui.",
  "empty_column.mutes": "Encara no has silenciau a garra usuario.",
  "empty_column.notifications": "No tiens garra notificación encara. Interactúa con atros pa empecipiar una conversación.",
  "empty_column.public": "No i hai cosa aquí! Escribe bella cosa publicament, u sigue usuarios d'atras instancias manualment pa emplir-lo",
  "error.unexpected_crash.explanation": "A causa d'una error en o nuestro codigo u a un problema de compatibilidat con o navegador, esta pachina no s'ha puesto amostrar correctament.",
  "error.unexpected_crash.explanation_addons": "No se podió amostrar correctament esta pachina. Esta error probablement estió causau per un complemento d'o navegador web u per ferramientas de traducción automatica.",
  "error.unexpected_crash.next_steps": "Intenta actualizar la pachina. Si ixo no aduya, ye posible que puedas usar Mastodon a traviés d'unatro navegador u aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Intenta deshabilitar-los y recarga la pachina. Si ixo no aduya, podrías usar Mastodon a traviés d'un navegador web diferent u aplicación nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar lo seguimiento de pila en o portafuellas",
  "errors.unexpected_crash.report_issue": "Informar d'un problema/error",
  "explore.trending_links": "Noticias",
  "explore.trending_statuses": "Publicacions",
  "explore.trending_tags": "Etiquetas",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de filtro no s'aplica a lo contexto en o qual ha accediu a esta publlicación. Si quiers que la publicación sía filtrada tamién en este contexto, habrás d'editar lo filtro.",
  "filter_modal.added.context_mismatch_title": "Lo contexto no coincide!",
  "filter_modal.added.expired_explanation": "Esta categoría de filtro ha caducau, amenesterá cambiar la calendata de caducidat pa que s'aplique.",
  "filter_modal.added.expired_title": "Filtro caducau!",
  "filter_modal.added.review_and_configure": "Pa revisar y configurar esta categoría de filtros, vaiga a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Achustes de filtro",
  "filter_modal.added.settings_link": "pachina d'achustes",
  "filter_modal.added.short_explanation": "Esta publicación ha estau anyadida a la siguient categoría de filtros: {title}.",
  "filter_modal.added.title": "Filtro anyadiu!",
  "filter_modal.select_filter.context_mismatch": "no s'aplica a este contexto",
  "filter_modal.select_filter.expired": "expirau",
  "filter_modal.select_filter.prompt_new": "Nueva categoría: {name}",
  "filter_modal.select_filter.search": "Buscar u creyar",
  "filter_modal.select_filter.subtitle": "Usar una categoría existent u creyar una nueva",
  "filter_modal.select_filter.title": "Filtrar esta publicación",
  "filter_modal.title.status": "Filtrar una publicación",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Refusar",
  "follow_requests.unlocked_explanation": "Tot y que la tuya cuenta no ye privada, lo personal de {domain} ha pensau que talment habrías de revisar manualment las solicitutz de seguimiento d'estas cuentas.",
  "footer.about": "Sobre",
  "footer.directory": "Directorio de perfils",
  "footer.get_app": "Obtener l'aplicación",
  "footer.keyboard_shortcuts": "Alcorces de teclau",
  "footer.privacy_policy": "Politica de privacidat",
  "footer.source_code": "Veyer codigo fuent",
  "generic.saved": "Alzau",
  "getting_started.heading": "Primers pasos",
  "hashtag.column_header.tag_mode.all": "y {additional}",
  "hashtag.column_header.tag_mode.any": "u {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "No se troboron sucherencias",
  "hashtag.column_settings.select.placeholder": "Escriba hashtags…",
  "hashtag.column_settings.tag_mode.all": "Qualsequiera d'estes",
  "hashtag.column_settings.tag_mode.any": "Qualsequiera d'estes",
  "hashtag.column_settings.tag_mode.none": "Garra d'estes",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "Seguir etiqueta",
  "hashtag.unfollow": "Deixar de seguir etiqueta",
  "home.column_settings.show_reblogs": "Amostrar retutz",
  "home.column_settings.show_replies": "Amostrar respuestas",
  "home.hide_announcements": "Amagar anuncios",
  "home.show_announcements": "Amostrar anuncios",
  "interaction_modal.on_another_server": "En un servidor diferent",
  "interaction_modal.on_this_server": "En este servidor",
  "intervals.full.days": "{number, plural, one {# día} other {# días}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# menuto} other {# menutos}}",
  "keyboard_shortcuts.back": "Tornar enta zaga",
  "keyboard_shortcuts.blocked": "Ubrir una lista d'usuarios blocaus",
  "keyboard_shortcuts.boost": "Retutar",
  "keyboard_shortcuts.column": "Enfocar en una d'as columnas",
  "keyboard_shortcuts.compose": "Enfocar l'aria de redacción de texto",
  "keyboard_shortcuts.description": "Descripción",
  "keyboard_shortcuts.down": "Mover enta baixo en a lista",
  "keyboard_shortcuts.enter": "Ubrir estau",
  "keyboard_shortcuts.federated": "Ubrir la linia de tiempo federada",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "Ubrir linia de tiempo",
  "keyboard_shortcuts.hotkey": "Tecla calient",
  "keyboard_shortcuts.legend": "Amostrar esta leyenda",
  "keyboard_shortcuts.local": "Ubrir linia de tiempo local",
  "keyboard_shortcuts.mention": "Mencionar a l'autor",
  "keyboard_shortcuts.muted": "Ubrir la lista d'usuarios silenciaus",
  "keyboard_shortcuts.my_profile": "Ubrir lo tuyo perfil",
  "keyboard_shortcuts.notifications": "Ubrir la columna de notificacions",
  "keyboard_shortcuts.open_media": "Ubrir fichers multimedia",
  "keyboard_shortcuts.pinned": "Ubrir la lista de publicacions destacadas",
  "keyboard_shortcuts.profile": "Ubrir lo perfil de l'autor",
  "keyboard_shortcuts.reply": "Responder publicación",
  "keyboard_shortcuts.requests": "Ubrir la lista de peticions de seguidores",
  "keyboard_shortcuts.search": "Meter lo foco en a busqueda",
  "keyboard_shortcuts.spoilers": "Amostrar/amagar lo campo CW",
  "keyboard_shortcuts.start": "Ubrir la columna \"prencipiar\"",
  "keyboard_shortcuts.toggle_hidden": "Amostrar/amagar lo texto marcau como sensible",
  "keyboard_shortcuts.toggle_sensitivity": "Amostrar/amagar fichers multimedia",
  "keyboard_shortcuts.toot": "Prencipia una nueva publicación",
  "keyboard_shortcuts.unfocus": "Retirar lo foco d'a caixa de redacción/busqueda",
  "keyboard_shortcuts.up": "Ir enta alto en a lista",
  "lightbox.close": "Zarrar",
  "lightbox.next": "Siguient",
  "lightbox.previous": "Anterior",
  "limited_account_hint.action": "Amostrar perfil de totz modos",
  "limited_account_hint.title": "Este perfil ha estau amagau per los moderadors de {domain}.",
  "lists.delete": "Borrar lista",
  "lists.edit": "Editar lista",
  "lists.replies_policy.followed": "Qualsequier usuario seguiu",
  "lists.replies_policy.list": "Miembros d'a lista",
  "lists.replies_policy.none": "Dengún",
  "load_pending": "{count, plural, one {# nuevo elemento} other {# nuevos elementos}}",
  "moved_to_account_banner.text": "La tuya cuenta {disabledAccount} ye actualment deshabilitada perque t'has mudau a {movedToAccount}.",
  "navigation_bar.about": "Sobre",
  "navigation_bar.blocks": "Usuarios blocaus",
  "navigation_bar.bookmarks": "Marcadors",
  "navigation_bar.domain_blocks": "Dominios amagaus",
  "navigation_bar.filters": "Parolas silenciadas",
  "navigation_bar.follow_requests": "Solicitutz pa seguir-te",
  "navigation_bar.follows_and_followers": "Seguindo y seguidores",
  "navigation_bar.lists": "Listas",
  "navigation_bar.logout": "Zarrar sesión",
  "navigation_bar.mutes": "Usuarios silenciaus",
  "navigation_bar.preferences": "Preferencias",
  "navigation_bar.search": "Buscar",
  "not_signed_in_indicator.not_signed_in": "Amenestes iniciar sesión pa acceder ta este recurso.",
  "notification.admin.report": "{name} informó {target}",
  "notification.admin.sign_up": "{name} se rechistró",
  "notification.follow": "{name} t'empecipió a seguir",
  "notification.follow_request": "{name} ha solicitau seguir-te",
  "notification.own_poll": "La tuya enqüesta ha rematau",
  "notification.reblog": "{name} ha retutau la tuya publicación",
  "notification.status": "{name} acaba de publicar",
  "notification.update": "{name} editó una publicación",
  "notifications.clear": "Limpiar notificacions",
  "notifications.clear_confirmation": "Seguro que quiers limpiar permanentment totas las tuyas notificacions?",
  "notifications.column_settings.admin.report": "Nuevos informes:",
  "notifications.column_settings.admin.sign_up": "Nuevos rechistros:",
  "notifications.column_settings.alert": "Notificacions d'escritorio",
  "notifications.column_settings.follow": "Nuevos seguidores:",
  "notifications.column_settings.follow_request": "Nuevas solicitutz de seguimiento:",
  "notifications.column_settings.mention": "Mencions:",
  "notifications.column_settings.poll": "Resultaus d'a votación:",
  "notifications.column_settings.push": "Notificacions push",
  "notifications.column_settings.reblog": "Retutz:",
  "notifications.column_settings.show": "Amostrar en columna",
  "notifications.column_settings.sound": "Reproducir son",
  "notifications.column_settings.status": "Nuevas publicacions:",
  "notifications.column_settings.unread_notifications.category": "Notificacions sin leyer",
  "notifications.column_settings.unread_notifications.highlight": "Destacar notificacions no leyidas",
  "notifications.column_settings.update": "Edicions:",
  "notifications.filter.all": "Totz",
  "notifications.filter.boosts": "Retutz",
  "notifications.filter.follows": "Seguidores",
  "notifications.filter.mentions": "Mencions",
  "notifications.filter.polls": "Resultaus d'a votación",
  "notifications.filter.statuses": "Actualizacions de chent a la quala sigues",
  "notifications.grant_permission": "Conceder permiso.",
  "notifications.group": "{count} notificacions",
  "notifications.mark_as_read": "Marcar totas las notificacions como leyidas",
  "notifications.permission_denied": "No se pueden habilitar las notificacions d'escritorio ya que se denegó lo permiso",
  "notifications.permission_denied_alert": "No se pueden habilitar las notificacions d'escritorio, ya que lo permiso d'o navegador estió denegau anteriorment",
  "notifications.permission_required": "Las notificacions d'escritorio no son disponibles perque no s'ha concediu lo permiso requeriu.",
  "notifications_permission_banner.enable": "Habilitar notificacions d'escritorio",
  "notifications_permission_banner.how_to_control": "Pa recibir notificacions quan Mastodon no sía ubierto, habilite las notificacions d'escritorio. Puetz controlar con precisión qué tipos d'interaccions cheneran notificacions d'escritorio a traviés d'o botón {icon} d'alto una vegada que sían habilitadas.",
  "notifications_permission_banner.title": "Nunca te pierdas cosa",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Zarrada",
  "poll.refresh": "Actualizar",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Has votau a favor d'esta respuesta",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Anyadir una enqüesta",
  "poll_button.remove_poll": "Eliminar enqüesta",
  "privacy.change": "Achustar privacidat",
  "privacy.public.short": "Publico",
  "privacy_policy.last_updated": "Ultima vegada actualizau {date}",
  "privacy_policy.title": "Politica de Privacidat",
  "refresh": "Actualizar",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "fa {number, plural, one {# día} other {# días}}",
  "relative_time.full.hours": "fa {number, plural, one {# hora} other {# horas}}",
  "relative_time.full.just_now": "chusto agora",
  "relative_time.full.minutes": "fa {number, plural, one {# menuto} other {# menutos}}",
  "relative_time.full.seconds": "fa {number, plural, one {# segundo} other {# segundos}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "hue",
  "reply_indicator.cancel": "Cancelar",
  "report.block": "Blocar",
  "report.block_explanation": "No veyerás las suyas publicacions. No podrán veyer las tuyas publicacions ni seguir-te. Podrán saber que son blocaus.",
  "report.categories.other": "Atros",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Lo conteniu viola una u mas reglas d'o servidor",
  "report.category.subtitle": "Tría la millor coincidencia",
  "report.category.title": "Conta-nos lo que ye pasando con este {type}",
  "report.category.title_account": "perfil",
  "report.category.title_status": "publicacion",
  "report.close": "Feito",
  "report.comment.title": "I hai bella cosa mas que creigas que habríanos de saber?",
  "report.forward": "Reninviar a {target}",
  "report.forward_hint": "Esta cuenta ye d'unatro servidor. Ninviar una copia anonimizada de l'informe allí tamién?",
  "report.mute": "Silenciar",
  "report.mute_explanation": "No veyerás las suyas publicacions. Encara pueden seguir-te y veyer los tuyos mensaches y no sabrán que son silenciaus.",
  "report.next": "Siguient",
  "report.placeholder": "Comentarios adicionals",
  "report.reasons.dislike": "No me fa goyo",
  "report.reasons.dislike_description": "No ye bella cosa que quieras veyer",
  "report.reasons.other": "Ye unatra coseta",
  "report.reasons.other_description": "Lo problema no encaixa en atras categorías",
  "report.reasons.spam": "Ye spam",
  "report.reasons.spam_description": "Vinclos maliciosos, interaccions falsas u respuestas repetitivas",
  "report.reasons.violation": "Viola las reglas d'o servidor",
  "report.reasons.violation_description": "Yes conscient que infrinche las normas especificas",
  "report.rules.subtitle": "Tría totz los que correspondan",
  "report.rules.title": "Qué normas se son violando?",
  "report.statuses.subtitle": "Tría totz los que correspondan",
  "report.statuses.title": "I hai bella publicación que refirme este informe?",
  "report.submit": "Ninviar",
  "report.target": "Denunciando a {target}",
  "report.thanks.take_action": "Aquí son las tuyas opcions pa controlar lo que veyes en Mastodon:",
  "report.thanks.take_action_actionable": "Mientres revisamos esto, puetz prener medidas contra @{name}:",
  "report.thanks.title": "No quiers esto?",
  "report.thanks.title_actionable": "Gracias per informar, estudiaremos esto.",
  "report.unfollow": "Deixar de seguir a @{name}",
  "report.unfollow_explanation": "Yes seguindo esta cuenta. Pa no veyer las suyas publicacions en a tuya muro d'inicio, deixa de seguir-la.",
  "report_notification.attached_statuses": "{count, plural, one {{count} tut adchunto} other {{count} tutz adchuntos}}",
  "report_notification.categories.other": "Atros",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Infracción de regla",
  "report_notification.open": "Ubrir informe",
  "search.placeholder": "Buscar",
  "search.search_or_paste": "Buscar u apegar URL",
  "search_popout.full_text_search_logged_out_message": "Nomás disponible iniciando la sesión.",
  "search_results.all": "Totz",
  "search_results.hashtags": "Etiquetas",
  "search_results.statuses": "Publicacions",
  "server_banner.about_active_users": "Usuarios activos en o servidor entre los zaguers 30 días (Usuarios Activos Mensuals)",
  "server_banner.active_users": "usuarios activos",
  "server_banner.administered_by": "Administrau per:",
  "server_banner.server_stats": "Estatisticas d'o servidor:",
  "sign_in_banner.create_account": "Creyar cuenta",
  "sign_in_banner.sign_in": "Iniciar sesión",
  "status.admin_account": "Ubrir interficie de moderación pa @{name}",
  "status.admin_domain": "Ubrir interficie de moderación pa {domain}",
  "status.admin_status": "Ubrir este estau en a interficie de moderación",
  "status.block": "Blocar a @{name}",
  "status.bookmark": "Anyadir marcador",
  "status.cancel_reblog_private": "Desfer retut",
  "status.cannot_reblog": "Esta publicación no se puede retutar",
  "status.copy": "Copiar vinclo a lo estau",
  "status.delete": "Borrar",
  "status.detailed_status": "Vista de conversación detallada",
  "status.edit": "Editar",
  "status.edited_x_times": "Editau {count, plural, one {{count} vez} other {{count} veces}}",
  "status.filter": "Filtrar esta publicación",
  "status.history.created": "{name} creyó {date}",
  "status.history.edited": "{name} editó {date}",
  "status.load_more": "Cargar mas",
  "status.media_hidden": "Conteniu multimedia amagau",
  "status.mention": "Mencionar @{name}",
  "status.more": "Más",
  "status.mute": "Silenciar @{name}",
  "status.mute_conversation": "Silenciar conversación",
  "status.open": "Expandir estau",
  "status.pin": "Fixar",
  "status.read_more": "Leyer mas",
  "status.reblog": "Retutar",
  "status.reblogged_by": "Retutau per {name}",
  "status.reblogs.empty": "Dengún no ha retutau encara este tut. Quan belún lo faiga, amaneixerá aquí.",
  "status.redraft": "Borrar y tornar ta borrador",
  "status.remove_bookmark": "Eliminar marcador",
  "status.replied_to": "Respondió a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder a lo filo",
  "status.report": "Denunciar €{name}",
  "status.sensitive_warning": "Conteniu sensible",
  "status.share": "Compartir",
  "status.show_less_all": "Amostrar menos pa tot",
  "status.show_more_all": "Amostrar mas pa tot",
  "status.show_original": "Amostrar orichinal",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Traducir",
  "status.translated_from_with": "Traduciu de {lang} usando {provider}",
  "status.unmute_conversation": "Deixar de silenciar conversación",
  "status.unpin": "Deixar de fixar",
  "subscribed_languages.lead": "Nomás los mensaches en os idiomas triaus amaneixerán en o suyo inicio y atras linias de tiempo dimpués d'o cambio. Tríe garra pa recibir mensaches en totz los idiomas.",
  "subscribed_languages.save": "Alzar cambios",
  "subscribed_languages.target": "Cambiar idiomas suscritos pa {target}",
  "tabs_bar.home": "Inicio",
  "tabs_bar.notifications": "Notificacions",
  "time_remaining.days": "{number, plural, one {# día restante} other {# días restantes}}",
  "time_remaining.hours": "{number, plural, one {# hora restante} other {# horas restantes}}",
  "time_remaining.minutes": "{number, plural, one {# menuto restante} other {# menutos restantes}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{number, plural, one {# segundo restante} other {# segundos restantes}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} en os zaguers {days, plural, one {días} other {{days} días}}",
  "trends.trending_now": "Tendencia agora",
  "ui.beforeunload": "Lo tuyo borrador se perderá si sales de Mastodon.",
  "units.short.billion": "{count} MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} K",
  "upload_area.title": "Arrociega y suelta pa puyar",
  "upload_button.label": "Puyar imachens, un vido u un fichero d'audio",
  "upload_error.limit": "Limite de puyada de fichers excedido.",
  "upload_error.poll": "Puyada de fichers no permitida con enqüestas.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Puyando...",
  "upload_progress.processing": "Procesando…",
  "video.close": "Zarrar video",
  "video.download": "Descargar fichero",
  "video.exit_fullscreen": "Salir de pantalla completa",
  "video.expand": "Expandir video",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Amagar video",
  "video.pause": "Pausar",
  "video.play": "Reproducir"
}
